import React, { createContext, useContext, useState } from 'react';

type SurveyContextType = {
	survey: Survey;
	setSurvey: React.Dispatch<React.SetStateAction<Survey>>;
};

const SurveyContext = createContext<SurveyContextType | undefined>(undefined);

const SurveyProvider = ({ defaultSurvey, children }: { defaultSurvey: Survey; children: React.ReactNode }): React.ReactElement => {
	const [survey, setSurvey] = useState<Survey>(defaultSurvey);

	return <SurveyContext.Provider value={{ survey, setSurvey }}>{children}</SurveyContext.Provider>;
};

const useSurveyContext = (): SurveyContextType => {
	const context = useContext(SurveyContext);
	if (context === undefined) {
		throw new Error('useSurveyContext must be used within a SurveyProvider');
	}
	return context;
};

export { SurveyProvider, useSurveyContext };
